import $ from "jquery";
import Swiper, {Scrollbar, Pagination} from 'swiper';

export default function featuredArticles() {
	if ($('.featured-articles__swiper').length > 0) {
		$(document).ready(function () {
			var swipers = $('.featured-articles__swiper');
			swipers.each(function (index) {
				let _self = $(this);
				_self.addClass('swiper-slider-' + index);
				let slideCount = parseInt(_self.find('.swiper-slide').length);
				let devide = 100 / slideCount;
				let dragSize = _self.find('.swiper-slide').length > 0 ? parseInt(devide) : 50;

				const swiper = new Swiper('.swiper-slider-' + index, {
					modules            : [Scrollbar, Pagination],
					speed              : 400,
					spaceBetween       : 100,
					slidesPerView      : 1,
					autoplay           : false,
					updateOnImagesReady: true,
					preloadImages      : false,
					lazyLoading        : true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					}
				});
			});

		});
	}
}
